import { getFilePath } from "../../../../utils";
import { ResponsiveImage } from "../../ResponsiveImage";
import { HomePage } from "../HomePage";
import { EmailLink, StyledLink } from "./Links";

export const TexasLandingPage: React.FC = () => (
  <HomePage
    voucherLandingContent={{
      heroSubtitle: "Practice Smarter, Master Faster",
      heroBody: (
        <div className="relative flex flex-col items-center gap-6 md:px-28">
          <p>
            Great news&mdash;DeltaMath for Home is now an approved Texas PDSES
            vendor! Support every learner at home with adaptive, differentiated
            math instruction that builds confidence and accelerates progress.
          </p>
          <ResponsiveImage
            className="-right-12 md:absolute"
            srcs={[
              getFilePath("/images/learner/home/third-party/pdses.png"),
              getFilePath("/images/learner/home/third-party/pdses@2x.png"),
            ]}
            alt="Texas PDSES Logo"
          />
        </div>
      ),
      cta: "Request a Quote",
      instructionsSubtitle:
        "To purchase DeltaMath for Home with your Texas PDSES funds, please follow the instructions below.",
      instructionsBody: (
        <>
          <ol className="flex list-decimal flex-col gap-1 pl-6">
            <li>
              Send an email with the following information to{" "}
              <EmailLink subject="PDSES ClassWallet Order" />:
              <ul className="flex list-disc flex-col gap-1 py-1 pl-6">
                <li>Subject Line: &ldquo;PDSES ClassWallet Order&rdquo;</li>
                <li>Parent First & Last Name</li>
                <li>
                  Parent Email Address (to be used for tracking, questions,
                  etc.)
                </li>
                <li>Parent Billing Address</li>
              </ul>
            </li>
            <li>
              Check your email to receive your quote within 1 business day
            </li>
            <li>
              Watch this short video to see how to easily upload your quote to
              ClassWallet.{" "}
              <StyledLink
                to="https://www.youtube.com/watch?v=vt0oLysesB4"
                target="_blank"
                rel="noopener noreferrer"
              >
                Watch Now!
              </StyledLink>
            </li>
            <li>
              Keep an eye out for communication from DeltaMath for Home, on next
              steps to opening your account
            </li>
          </ol>
          <p>
            For assistance with an order or the status of an order, please email{" "}
            <EmailLink />.
          </p>
        </>
      ),
    }}
  />
);
